// ********************************************************
// Scan Mobile
// Handles stuff like view and submit weights from Scan Mobile.
// ********************************************************

import * as Backend from '@/core/backend'

export async function loadRegistrations (params) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.LoadRegistrations',
    inputData: {
      Facility: params.Facility,
      RegistrationType: params.RegistrationType
    }
  })
  if (!res.failed && res.data !== null) {
    // Sort so newest is top-most
    res.data = res.data.sort((a, b) => (a.CreatedData < b.CreatedData) ? 1 : ((b.CreatedData < a.CreatedData) ? -1 : 0))
  }
  return res
}

export async function loadRegistration (id) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.LoadRegistration',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function unfinishRegistration (id) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.UnfinishRegistration',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function loadAgreementFromDelivery (params) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.LoadAgreementDelivery',
    inputData: {
      Facility: params.Facility,
      DeliveryNo: params.No
    }
  })
  return res
}

export async function captureImageMsg (params) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.CaptureImageMsg',
    inputData: {
      FacilityNo: params.facilityNo,
      VehicleNo: params.vehicleNo,
      Indicator: params.indicator
    }
  })
  return res
}

export async function loadFacilityData (params) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.LoadFacilityData',
    inputData: {
      FacilityNo: params.facilityNo,
      CorpName: params.corpName
    }
  })
  return res
}

export async function isUsedRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.IsUsedRegistration',
    inputData: {
      Facility: params.Facility,
      ScanXRegNo: params.ScanXRegNo
    }
  })
  return res
}

export async function loadScanXRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.LoadScanXRegistration',
    inputData: {
      Facility: params.Facility,
      ScanXRegNo: params.ScanXRegNo
    }
  })
  return res
}

export async function getCurrentWeightIds (params) {
  const res = await Backend.callApi({
    apiName: 'ScaleWeight.GetCurrentWeightIds',
    inputData: {
      facility: params
    }
  })
  return res
}

export async function getWeight (params) {
  const res = await Backend.callApi({
    apiName: 'ScaleWeight.GetWeight',
    inputData: {
      ScaleId: params.VT25Id
    }
  })
  return res
}

export async function getTempTare (params) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.GetCurrentTempTare',
    inputData: {
      VehicleId: params
    }
  })
  return res
}

export async function loadDeliveryInspectionRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.LoadDeliveryInspectionRegistration',
    inputData: {
      Facility: params.Facility,
      RegistrationNo: params.RegistrationNo
    }
  })
  return res
}

export async function getVehicleNr (params) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.GetVehicle',
    inputData: {
      Facility: params.Facility,
      VehicleId: params.No
    }
  })
  return res
}

export async function setTempTare (params) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.SetTempTare',
    inputData: {
      VehicleId: params.VehicleId,
      Weight: params.Weight
    }
  })
  return res
}

export async function clearTempTare (VehicleId) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.ClearTempTare',
    inputData: {
      VehicleId: VehicleId
    }
  })
  return res
}

export async function loadRegistrationHistory (params) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.LoadRegistrationHistory',
    inputData: {
      Facility: params.Facility,
      VehicleNo: params.VehicleNo
    }
  })
  return res
}

export async function loadFirstRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.LoadFirstRegistration',
    inputData: {
      Facility: params.Facility,
      VehicleNo: params.VehicleNo
    }
  })
  return res
}

export async function saveRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.SaveRegistration',
    inputData: {
      Registration: params,
      TransferRegistration: params.TransferRegistration
    }
  })
  return res
}

export async function printRegistration (id) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.PrintRegistration',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function uploadWeight (params) {
  const res = await Backend.callApi({
    apiName: 'ScanMobile.UploadWeight',
    inputData: {
      ScaleId: params.ScaleId,
      ScaleWeightData: params.ScaleWeightData
    }
  })
  return res
}

export async function loadVehicles (param) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadVehicles',
    inputData: {
      // MITH special: If facility is '' show all vehicles for all facilities (we use facility = null).
      Facility: param.facility === '' ? null : param.facility,
      SearchText: param.searchText,
      LoadDeleted: false // never load Deleted
    }
  })
  return res
}

export async function loadFilteredArticles (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadArticles',
    inputData: {
      Facility: params.facilityNo,
      ArticleNoFilter: params.ArticleNoFilter
    }
  })
  return res
}
